import { render, staticRenderFns } from "./OrdersPrintableView.vue?vue&type=template&id=0f9e2aa4"
import script from "./OrdersPrintableView.vue?vue&type=script&lang=js"
export * from "./OrdersPrintableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports